<template>
    <div>
        <my-header></my-header>
        <div class="df container">
            <img src="../../assets/img/not_found.png" alt="">
            <p>哎呀，页面找不到了~</p>
        </div>
        <my-footer></my-footer>
    </div>
</template>
<script>
export default {
    data(){
        return {

        }
    }
}
</script>
<style scoped>
.container{
    height: 800px;
    flex-direction: column;
    align-items: center;
    color: #999;
    font-size: 18px;
    text-align: center;
}
.container img{
    margin-top: 185px;
}
.container p{
    margin-top: 26px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/notfound.vue